import PropTypes from 'prop-types';
import { STORE_ID } from '@/constants/stores';
import styles from './FooterHeader.module.scss';
import FooterHeaderImage from './FooterHeaderImage';

const FooterHeader = ({ t, phone, storeId }) => (
	<div className={`row ${styles.reassurance}`}>
		<div className="col-6 col-md-3">
			<div className={styles.item}>
				<div className={styles.icon}>
					<FooterHeaderImage name="livraison" />
				</div>
				<span className={styles.title}>{`${t('footer.reassurance.delivery')}`}</span>
				{storeId === STORE_ID.USA && <span className={styles.text}>{`${t('footer.reassurance.deliveryTime')}`}</span>}
			</div>
		</div>
		<div className="col-6 col-md-3">
			<div className={styles.item}>
				<div className={styles.icon}>
					<FooterHeaderImage name="support-white" />
				</div>
				<span className={styles.title}>{`${t('footer.reassurance.customAdvice')}`}</span>{' '}
				<span className={styles.text}>{phone}</span>{' '}
				{t('footer.reassurance.freeCall') !== '' && (
					<span className={styles.text}>{`(${t('footer.reassurance.freeCall')})`}</span>
				)}
			</div>
		</div>
		<div className="col-6 col-md-3">
			<div className={styles.item}>
				<div className={styles.icon}>
					<FooterHeaderImage name="paiement" />
				</div>
				<span className={styles.title}>{`${t('footer.reassurance.payment')}`}</span>
			</div>
		</div>
		<div className="col-6 col-md-3">
			<div className={styles.item}>
				<div className={styles.icon}>
					<FooterHeaderImage name="origine" />
				</div>
				<span className={styles.title}>{`${t('footer.reassurance.origin')}`}</span>{' '}
				<span className={styles.text}>{`${t('footer.reassurance.provenance')}`}</span>
			</div>
		</div>
	</div>
);

FooterHeader.propTypes = {
	phone: PropTypes.string.isRequired,
	storeId: PropTypes.string.isRequired,
	t: PropTypes.func.isRequired,
};

export default FooterHeader;
